function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Telegram, Negative",
    clipPath: "url(#clip0_4457_72760)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9995 11.9998C23.9995 18.627 18.627 23.9995 11.9998 23.9995C5.37247 23.9995 0 18.627 0 11.9998C0 5.37247 5.37247 0 11.9998 0C18.627 0 23.9995 5.37247 23.9995 11.9998ZM12.4298 8.85875C11.2626 9.34421 8.92996 10.349 5.43178 11.8731C4.86373 12.099 4.56616 12.32 4.53908 12.536C4.49329 12.9012 4.95061 13.045 5.57336 13.2409C5.65807 13.2675 5.74584 13.2951 5.83582 13.3243C6.44851 13.5235 7.27268 13.7565 7.70113 13.7658C8.08978 13.7741 8.52355 13.6139 9.00246 13.2851C12.2709 11.0788 13.9581 9.96361 14.064 9.93957C14.1388 9.92261 14.2423 9.90128 14.3125 9.96364C14.3826 10.026 14.3757 10.1441 14.3683 10.1758C14.323 10.3689 12.5279 12.0378 11.5989 12.9015C11.3093 13.1708 11.1038 13.3617 11.0619 13.4054C10.9678 13.5031 10.8719 13.5955 10.7798 13.6843C10.2106 14.233 9.78371 14.6445 10.8034 15.3165C11.2934 15.6394 11.6855 15.9064 12.0767 16.1728C12.5039 16.4638 12.93 16.7539 13.4813 17.1153C13.6218 17.2074 13.7559 17.303 13.8866 17.3962C14.3838 17.7506 14.8304 18.069 15.3823 18.0183C15.7029 17.9888 16.0341 17.6873 16.2023 16.788C16.5999 14.6628 17.3813 10.0583 17.5619 8.16081C17.5777 7.99457 17.5578 7.78181 17.5418 7.68842C17.5258 7.59502 17.4924 7.46196 17.371 7.36345C17.2272 7.24679 17.0053 7.22219 16.906 7.22394C16.4547 7.23189 15.7622 7.47266 12.4298 8.85875Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4457_72760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9995,
    height: 23.9995,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.a5421cd6d2077a597d1daa430be7b89e.svg";
export { ForwardRef as ReactComponent };